import styled from 'styled-components';

export const SVGElem = styled.svg`
  fill: none;
`;

export const GroupElem = styled.g``;

export const RectElem = styled.rect``;

export const TextElem = styled.text`
  font-family: 'Roboto';
  font-size: 14px;
  font-weight: 700;
`;
